module.exports = __webpack_public_path__ + "static/media/logo.12b898f0.svg";